import React from "react";
import { FormOptionGroup } from "mesh-component-library";

type AccidentQuestionsProps = {
  onChange: (e: React.FormEvent<HTMLFieldSetElement>) => void;
  response: string;
};

export const AccidentQuestions = ({ onChange, response }: AccidentQuestionsProps) => (
  <FormOptionGroup
    label="Was this vehicle involved in an accident?"
    onChange={onChange}
    options={[
      {
        id: "accident-option-1",
        name: "accident-options",
        text: "Yes",
        value: "Yes",
        defaultChecked: "Yes" === response,
      },
      {
        id: "accident-option-2",
        name: "accident-options",
        text: "No",
        value: "No",
        defaultChecked: "No" === response,
      },
    ]}
    type="radio"
    required={true}
  />
);